import { ButtonSkeleton } from 'src/modules/shared/components/atoms/buttons/button-skeleton';
import { TagSkeleton } from 'src/modules/shared/components/atoms/tag/tag-skeleton';
import { TextSkeleton } from 'src/modules/shared/components/atoms/text/text-skeleton';

interface ConversationHeaderSkeletonProps {
  showMetadata?: boolean;
  isSmallScreen?: boolean;
}

const IconOnlyButtonSkeleton = ({ size = 'h-9 w-9' }: { size?: string }) => (
  <div
    className={`${size} flex-shrink-0 animate-pulse rounded-lg bg-secondary-100`}
    aria-hidden="true"
  />
);

export const ConversationHeaderSkeleton: React.FC<
  ConversationHeaderSkeletonProps
> = ({ showMetadata = true, isSmallScreen = false }) => {
  if (!showMetadata) {
    return (
      <div className="flex min-h-[56px] items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-3">
          <IconOnlyButtonSkeleton />

          <div className="h-12 w-12 flex-shrink-0 animate-pulse rounded-full bg-secondary-100" />

          <div className="min-w-0 space-y-2">
            <TextSkeleton
              variant="secondary"
              className="h-5 w-40 rounded bg-secondary-100"
            />
          </div>
        </div>

        <div className="flex items-center gap-2">
          <ButtonSkeleton
            size="md"
            variant="secondary"
            className="w-20 rounded-xl border-0"
          />
          <ButtonSkeleton
            size="md"
            variant="neutral"
            className="w-9 rounded-full border-0"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-[auto_minmax(0,1fr)_auto] gap-x-2 gap-y-2 sm:gap-x-3">
      <div className="row-span-2 flex min-h-full items-center">
        <IconOnlyButtonSkeleton size={isSmallScreen ? 'h-8 w-8' : 'h-9 w-9'} />
      </div>

      <div className="flex min-w-0 items-center gap-3 py-0.5">
        <div className="h-12 w-12 flex-shrink-0 animate-pulse rounded-full bg-secondary-100" />
        <div className="flex min-w-0 items-center gap-2">
          <TextSkeleton
            variant="secondary"
            className="h-6 w-40 rounded bg-secondary-100"
          />
          <div className="h-5 w-5 flex-shrink-0 animate-pulse rounded bg-secondary-100" />
        </div>
      </div>

      <div className="row-span-2 flex min-h-full items-center justify-self-end gap-2">
        <ButtonSkeleton
          size={isSmallScreen ? 'sm' : 'md'}
          variant="secondary"
          className="w-20 rounded-xl border-0"
        />
        <ButtonSkeleton
          size={isSmallScreen ? 'sm' : 'md'}
          variant="neutral"
          className="w-9 rounded-full border-0"
        />
      </div>

      <div className="col-span-3 flex min-w-0 items-center gap-2 overflow-hidden px-1 pt-0.5">
        <TagSkeleton size="xs" variant="neutral" withIcon />
        <TagSkeleton
          size="xs"
          variant="neutral"
          withIcon
          iconPosition="right"
        />
        <TagSkeleton
          size="xs"
          variant="neutral"
          withIcon
          iconPosition="right"
        />
      </div>
    </div>
  );
};
